// extracted by mini-css-extract-plugin
export default {"wrapper":"_ZrBUJnc6rfSHpQ18bGG","container":"ZfU93Ku58AlRgtFa8mrc","title":"P6Q4LWfsvEkRgxztg7qR","subtitle":"f4KCLAPFpFfNiUFdrl8p","actions":"R3OhKWB_VeBsiapFJuxA"};